import React from 'react';
import { NumericInput, Pane, PropertyGrid, Selector } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { ns } from '@leverege/i18n';
import LineSeriesModel from "../../models/series/LineSeriesModel.js";
import { SELECTOR_OPTS } from "../../models/series/Curves.js";
const {
  t
} = ns('ui-attributes-graphs.editors.LineSeriesEditor');
export default function LineSeriesEditor(props) {
  const {
    value
  } = props;
  const onModelChange = useValueChange(LineSeriesModel, props);
  return /*#__PURE__*/React.createElement(PropertyGrid, {
    variant: "seriesEditor|editor",
    inline: true
  }, /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('transparency')
  }, /*#__PURE__*/React.createElement(NumericInput, {
    hint: t('transparencyHint'),
    value: LineSeriesModel.getStrokeOpacity(value),
    eventData: "setStrokeOpacity",
    min: 0,
    max: 1,
    float: true,
    onChange: onModelChange
  })), /*#__PURE__*/React.createElement(PropertyGrid.Item, {
    label: t('curve')
  }, /*#__PURE__*/React.createElement(Selector, {
    values: SELECTOR_OPTS,
    value: LineSeriesModel.getCurve(value),
    eventData: "setCurve",
    onChange: onModelChange
  })));
}